import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import CadastrarInsumoRecord from '@components/InsumoRecord/CadastrarInsumoRecord';
import formatMessage from './i18n/formatMessage';
import Insumo from '@resources/InsumosEnum';
import { withRouter } from 'react-router-dom';

/**
 * Tela para cadastro de Oleos Adjuvantes
 *
 * @author Gabriela Farias <gabriela.farias@kepha.com.br>
 * @param {*} props
 * @returns {JSX.Element}
 */
function EditarOleosAdjuvantes(props) {
  useEffect(() => {
    const title = 'oleosAdjuvantes.cadastroDeOleosAdjuvantes';
    if (props.itensState.name !== title) {
      props.dispatch({ type: 'UPDATE_TOOLBAR', toolbar: formatMessage(title), name: title });
    }
  }, []);

  return (
    <CadastrarInsumoRecord
      id={props.match.params.id}
      insumoURL={'oleos'}
      insumoEnum={Insumo.OLEOS_ADJUVANTES}
      infoUsuario={props.infoUsuario}
      saveMessage={formatMessage(
        'oleosAdjuvantes.' +
          (props.match.params.id
            ? 'oleosAdjuvantesEditadoComSucesso'
            : 'oleosAdjuvantesCadastradoComSucesso')
      )}
      falhaSaveMesssage={formatMessage(
        'oleosAdjuvantes.' +
          (props.match.params.id
            ? 'falhaAoEditarOleosAdjuvantes'
            : 'falhaAoCadastrarOleosAdjuvantes')
      )}
      falhaCarregarMensagem={formatMessage('oleosAdjuvantes.falhaAoCarregarOleosAdjuvantes')}
    />
  );
}

const mapStateToProps = state => ({
  itensState: state.toolbar,
  infoUsuario: state.adicionarInfoUsuario.info
});

export default withRouter(connect(mapStateToProps)(EditarOleosAdjuvantes));
